var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsInfoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 24H0V0h24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20zm0 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16zm.159 6.25a1 1 0 0 1 .993.883l.007.117v3.25h.151a1 1 0 0 1 .117 1.993l-.117.007H11a1 1 0 0 1-.117-1.993L11 14.5h.159v-2.25h-.15a1 1 0 0 1-.993-.883l-.007-.117a1 1 0 0 1 .883-.993l.117-.007h1.15zm-.309-3.26c.664 0 1.223.53 1.25 1.201v.049a1.26 1.26 0 0 1-1.25 1.25c-.695 0-1.25-.57-1.25-1.25 0-.692.558-1.25 1.25-1.25z",
    fill: "#1E88E5",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsInfoCircle);
export default __webpack_public_path__ + "static/media/icons-info-circle.c7585c6a1be403aee83ccafe9dc08332.svg";
export { ForwardRef as ReactComponent };